export enum RevenueType {
  MERCHANT,
  CONTRACT_PPA,
  COMBINE
}
